const type = 'SET_INITIAL_DIMENSIONS';

const setInitialDimensions = (data) => ({
  type,
  data,
});

export { type };
export default setInitialDimensions;
